import React from "react";
import Seo from "../components/Seo";
import Tab from "../components/Tabs/TabBasic";
import Footer from "../components/Footer";

import Hero from "../components/Heros/HeroIntroduce";
import Cta from "../components/Cta";

const IntroductionPage = () => (
    <>
        <Seo
            title="회사소개"
            description="ICT융합기술을 기반으로 Digital Transformation과 융합기술 R&D를 전문으로 하는 연구소입니다. 공식 Databricks·Salesforce 파트너로서 데이터와 AI를 연결합니다."
            path="/about"
        />
        <Hero />
        <Tab />

        {/* <ColumnListandImage /> */}

        <Cta
                    preset="contact"
                    title={"KUSRC 와 \n 디지털 트랜스포메이션의 \n여정을 함께하세요."}
                />
        <Footer />
    </>
);

export default IntroductionPage;
